import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useSendPasswordReset } from 'api/OrganizationAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer/utils';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { spacing } from 'ui/theme';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { UnreadMail16 } from 'ui/icons/aurora/16px/UnreadMail16';
import { fullName } from '../../utils';
import { Member } from '../../types';
import { MemberOverflowMenu } from '../Shared/MemberOverflowMenu';

const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.half};
`;

export const PageHeaderActions = ({ member }: { member: Member }) => {
  const dispatch = useDispatch();

  const { mutate: sendInvitation } = useSendPasswordReset(member.userId, {
    onSuccess: () => {
      dispatch(addPositiveToast(`Invitation for ${fullName(member)} was sent successfully.`));
    },
    onError: (error: unknown) => {
      dispatch(
        addNegativeToastWithErrorId(
          `There was an error sending invitation to ${fullName(member)}. Please try again.`,
          'sendInvitation',
          error,
        ),
      );
    },
  });

  const memberIsActive = member?.lastLoginAt;
  const orgAdmin = member?.orgAdmin;
  const projectCount = member.projectMemberships?.length || 0;

  return (
    <Wrapper>
      {!memberIsActive && (
        <Tooltip
          isEnabled={!orgAdmin && projectCount < 1}
          tooltipContent={
            <span>
              Member must belong to at least one project before they can be sent an invitation.
            </span>
          }
        >
          <SecondaryButton
            size={BUTTON_SIZES.LARGE}
            isDisabled={!orgAdmin && projectCount < 1}
            onClick={() => {
              sendInvitation(undefined);
            }}
          >
            <UnreadMail16 />
            Send invitation
          </SecondaryButton>
        </Tooltip>
      )}
      <MemberOverflowMenu member={member} />
    </Wrapper>
  );
};
